import {
	Component,
	ChangeDetectionStrategy,
	Input
} from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import {
	Translate
} from '../../services';
import {
	UserActions,
	UserService
} from '../../logics';

@Component({
	selector: 'cs-lang-switch',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
	<div class="cs-lang-switch cs-lang-switch-{{mode}}">
		<div class="cs-form-btn-group">
			<button 
				class="cs-btn cs-btn"
				[ngClass]="{
					'disabled': (lang$ | async) === 'it'
				}"
				(click)="setLanguage('it')">
				<span *ngIf="mode === 'large'">
					{{ (translations$ | async)['global#lang_it'] }}
				</span>
				<span *ngIf="mode === 'small'">IT</span>
			</button>
			<button 
				class="cs-btn cs-btn"
				[ngClass]="{
					'disabled': (lang$ | async) === 'en'
				}"
				(click)="setLanguage('en')">
				<span *ngIf="mode === 'large'">
					{{ (translations$ | async)['global#lang_en'] }}
				</span>
				<span *ngIf="mode === 'small'">EN</span>
			</button>
		</div>
	</div>
	`
})
export class CsLangSwitchComponent {
	@Input() mode: string = 'large';

	translations$: Observable<any>;
	lang$: Observable<string>;

	constructor(
		private store: Store<any>,
		private userActions: UserActions,
		private userService: UserService,
		private translate: Translate,
	){
		this.translations$ = this.translate.getTranslations$();
		this.lang$ = this.userService.getLanguage$();

		// if cookie set language
		const cookie_lang = 'it';//this.userService.getCookieLanguage();
		if(cookie_lang){
			this.store.dispatch(this.userActions.setLanguage(cookie_lang));
		}
	}

	setLanguage(lang: string){
		this.store.dispatch(this.userActions.setLanguage(lang));
	}
}



// WEBPACK FOOTER //
// ./src/app/components/cs-lang-switch/cs-lang-switch.component.ts